import React from "react";
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Chip,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

const FlavorsTable = ({ data, onEdit, onDelete, onMoreInfo }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        maxWidth: "100%",
        overflowX: "auto",
      }}>
      <MuiTable>
        <TableHead>
          <TableRow
            sx={{
              "&:nth-of-type(odd)": { backgroundColor: "action.hover" },
              "&:hover": { backgroundColor: "action.selected" },
            }}>
            <TableCell>
              <Typography variant="subtitle2">Name</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2">Description</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2">Icing</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2">Price</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2">Dietary Tags</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2">Allergens</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2">Popularity</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2">Seasonal</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2">Image</Typography>
            </TableCell>
            <TableCell align="right">
              <Typography variant="subtitle2">Actions</Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((item) => (
            <TableRow key={item._id}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.description}</TableCell>

              {/* Icing */}
              <TableCell>{item.icing?.name || "Unknown Icing"}</TableCell>

              <TableCell>{item.price}</TableCell>

              {/* Dietary Tags */}
              <TableCell>
                {item.dietaryTags?.map((tag) =>
                  typeof tag === "string" ? (
                    <Chip key={tag} label={tag} size="small" sx={{ mr: 0.5 }} />
                  ) : (
                    <Chip
                      key={tag._id}
                      label={tag.label}
                      size="small"
                      color="secondary"
                      variant="outlined"
                      sx={{ mr: 0.5 }}
                    />
                  )
                )}
              </TableCell>

              {/* Allergens */}
              <TableCell>
                {item.allergens?.map((allergen) =>
                  typeof allergen === "string" ? (
                    <Chip
                      key={allergen}
                      label={allergen}
                      size="small"
                      sx={{ mr: 0.5 }}
                    />
                  ) : (
                    <Chip
                      key={allergen._id}
                      label={allergen.name}
                      size="small"
                      variant="outlined"
                      sx={{ mr: 0.5 }}
                    />
                  )
                )}
              </TableCell>

              <TableCell>{item.popularity}</TableCell>
              <TableCell>{item.seasonal ? "Yes" : "No"}</TableCell>

              <TableCell>
                <img
                  src={item.images?.primary}
                  alt={item.name || "No Image"}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </TableCell>

              <TableCell align="right">
                <Tooltip title="Edit" placement="top" arrow>
                  <IconButton
                    onClick={() => onEdit(item)}
                    sx={{ color: "#6E6E6E" }}
                    aria-label="edit">
                    <EditIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Delete" placement="top" arrow>
                  <IconButton
                    onClick={() => onDelete(item._id)}
                    sx={{ color: "#6E6E6E" }}
                    aria-label="delete">
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="More Info" placement="top" arrow>
                  <IconButton
                    onClick={() => onMoreInfo(item)}
                    sx={{ color: "#6E6E6E" }}
                    aria-label="more-info">
                    <InfoOutlined />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};

export default FlavorsTable;
